import { handleResponse } from "utils/utils";
import { authService } from "services";

export const dashboardsService = {
	getEmployeeHourSummary,
	getEmployeeVacationSummary,
	getEmployeeAbsenceCalendar,
};

// get employee's objective hours
function getEmployeeHourSummary(employeeId) {
	// Validación defensiva: evitar peticiones con undefined
	if (!employeeId || employeeId === 'undefined') {
		console.warn('getEmployeeHourSummary: employeeId es undefined o inválido');
		return Promise.resolve({ ok: false, error: 'Employee ID is required' });
	}

	const requestOptions = {
		method: "GET",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
		},
	};

	return fetch(`${global.BASE_API}dashboards/employees/${employeeId}/hour-summary`, requestOptions).then(
		handleResponse
	);
}

// get employee's vacation
function getEmployeeVacationSummary(employeeId, year) {
	// Validación defensiva: evitar peticiones con undefined
	if (!employeeId || employeeId === 'undefined') {
		console.warn('getEmployeeVacationSummary: employeeId es undefined o inválido');
		return Promise.resolve({ ok: false, error: 'Employee ID is required' });
	}

	const requestOptions = {
		method: "GET",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
		},
	};

	return fetch(`${global.BASE_API}dashboards/employees/${employeeId}/vacation-summary?year=${year}`, requestOptions).then(
		handleResponse
	);
}

// get employee's vacation calendar
function getEmployeeAbsenceCalendar(employeeId, year) {
	// Validación defensiva: evitar peticiones con undefined
	if (!employeeId || employeeId === 'undefined') {
		console.warn('getEmployeeAbsenceCalendar: employeeId es undefined o inválido');
		return Promise.resolve({ ok: false, error: 'Employee ID is required' });
	}

	const requestOptions = {
		method: "GET",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
		},
	};

	return fetch(`${global.BASE_API}dashboards/employees/${employeeId}/absence-calendar-summary?year=${year}`, requestOptions).then(
		handleResponse
	);
}
